export default __webpack_public_path__ + "static/media/draw_line.c0d73a87.svg";